import type { IProductLeanDto } from "./product-lean/product-lean.dto.interface";
import type { IProductsAvailabilitiesDto } from "./products-availabilities.dto.interface";

export class ProductsAvailabilitiesDto implements IProductsAvailabilitiesDto {
  available: IProductLeanDto[];
  notAvailable: IProductLeanDto[];

  constructor(data: IProductsAvailabilitiesDto) {
    this.available = data.available;
    this.notAvailable = data.notAvailable;
  }
}
